/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEditorial} from '../api'

 export const useQueryGetEditorial = createReactQueryHook('getEditorial', getEditorial)
